import request from "@/utils/request";
import { SERVERPATH } from "@/config";

// 登录
export function LoginByPass(data) {
  return request({
    url: `${SERVERPATH}/Login/loginByPass`,
    method: "post",
    data
  });
}

// 获取工作台信息
export function Indexindex(data) {
  return request({
    url: `${SERVERPATH}/Index/index`,
    method: "post",
    data
  });
}

// 会员等级列表
export function IndexMemberLevelList(data) {
  return request({
    url: `${SERVERPATH}/Index/memberLevelList`,
    method: "post",
    data
  });
}

// 会员身份列表
export function IndexMemberIdentityList(data) {
  return request({
    url: `${SERVERPATH}/Index/memberIdentityList`,
    method: "post",
    data
  });
}

// 获取标签
export function IndexLabelList(data) {
  return request({
    url: `${SERVERPATH}/Index/labelList`,
    method: "post",
    data
  });
}

// 新增标签
export function IndexLabelAdd(data) {
  return request({
    url: `${SERVERPATH}/Index/labelAdd`,
    method: "post",
    data
  });
}

// 删除标签
export function IndexLabelDel(data) {
  return request({
    url: `${SERVERPATH}/Index/labelDel`,
    method: "post",
    data
  });
}

// 获取省列表
export function IndexProvinceList(data) {
  return request({
    url: `/admin/System/provinceList`,
    method: "post",
    data
  });
}

// 获取市列表
export function IndexCityList(data) {
  return request({
    url: `/admin/System/cityList`,
    method: "post",
    data
  });
}

// 获取市列表
export function IndexProvinceCity(data) {
  return request({
    url: `/admin/System/provinceCity`,
    method: "post",
    data
  });
}

// 获取数据看板
export function Indexboard(data) {
  return request({
    url: `/admin/Index/board`,
    method: "post",
    data
  });
}
// 获取萝卜币使用情况
export function getMengTangJin(data) {
  return request({
    url: `/admin/Index/tongjimengtangjin`,
    method: "post",
    data
  });
}

// 下载微信对账单
export function IndexDownloadWechatBill(data) {
  return request({
    url: `/admin/Index/downloadWechatBill`,
    method: "post",
    data
  });
}

// 后台需求列表
export function IndexDemandList(params) {
  return request({
    url: `${SERVERPATH}/Index/demandList`,
    method: "get",
    params
  });
}

// 后台需求详情
export function IndexDemandInfo(params) {
  return request({
    url: `${SERVERPATH}/Index/demandInfo`,
    method: "get",
    params
  });
}

// 后台需求跟进
export function IndexDemandFollow(data) {
  return request({
    url: `${SERVERPATH}/Index/demandFollow`,
    method: "post",
    data
  });
}
